// import Vue from 'vue'
// import Router from 'vue-router'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)


const router = new VueRouter({
  routes: [
    // 首页
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/index')
    },
    // 记录页
    {
      path: '/record',
      name: 'record',
      component: () => import('@/views/record/index')
    },
    // 通知列表
    {
      path: '/notice',
      name: 'notice',
      component: () => import('@/views/notice/index')
    },
    // 通知详情
    {
      path: '/detail',
      name: 'detail',
      component: () => import('@/views/detail/index')
    },
    // 报课
    {
      path: '/apply',
      name: 'apply',
      component: () => import('@/views/apply/index')
    }
  ],
  mode: 'history'
  // scrollBehavior: () => ({ y: 0 }) //此特性不在支持
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next({
      path: '/'
    })
  } else {
    next()
  }
})
//打开页面返回顶部位置
router.afterEach((to, from) => {
  let bodySrcollTop = document.body.scrollTop
  if (bodySrcollTop !== 0) {
    document.body.scrollTop = 0
    return
  }
  let docSrcollTop = document.documentElement.scrollTop
  if (docSrcollTop !== 0) {
    document.documentElement.scrollTop = 0
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js